// Module
var code = `<div class="student-cluster" ng-class="brandStyleClass" ng-style="::style" ng-click="onClusterClick()"><span class="count">{{::feature.properties.count}}</span></div>`;
// Exports
export default code;